import { useNotify } from 'react-admin';
import { CancelButton, SaveButton } from 'shared/mui/Buttons';
import { CreateGuesserPage } from 'shared/react-admin/Pages/CreateGuesserPage/CreateGuesserPage';
import { ApiClient } from 'types/embedded/apiClient';

import { ApiClientsCreateForm } from './ApiClientsCreateForm';

const transform = (data: ApiClient): ApiClient => {
  return {
    ...data,
    merchant: data.merchant || null,
  };
};

export const ApiClientsCreate = () => {
  const notify = useNotify();

  return (
    <CreateGuesserPage
      listName="Клиенты API"
      mutationOptions={{
        onError: (error: Error) => {
          notify(`Ошибка: ${error.message || 'ошибка сервера'}`, {
            type: 'error',
            autoHideDuration: 3000,
          });
        },
      }}
      rightActionsSlot={[
        <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
        <SaveButton key="save-button" />,
      ]}
      title="Создание Клиента API"
      transform={transform}
    >
      <ApiClientsCreateForm />
    </CreateGuesserPage>
  );
};
